module.exports = __webpack_public_path__ + "static/media/step-indicator-2.edac2400.svg";